import { inject } from '@angular/core';
import { CodeSystem } from './models/code-system.model';
import { RosettaService } from './services/rosetta.service';
import { Observable } from 'rxjs';

export const codeSystemsResolver = (): Observable<CodeSystem[]> => {
  const rosetta = inject(RosettaService);
  return rosetta.getCodeSystems();
};
